import React, {useState} from 'react';
import {Flex, Form, Input, Modal} from "antd";
import CustomButton from "../../../UI/CustomButton/CustomButton";
import { ReactComponent as CrossIcon } from '../../../../assets/images/global-icons/cross_ic.svg';
import './EditCompanyLinkModal.scss';
import {useForm} from "antd/lib/form/Form";
import {useUpdateCompanyMutation} from "../../../../redux/API/companySlice";
import {useSelector} from "react-redux";
import {RootState} from "../../../../redux/store";
import {useUpdateProfileMutation} from "../../../../redux/API/userSlice";

interface EditCompanyLinkModalProps {
  visible: boolean;
  onClose: () => void;
  link: string,
  id?: string,
  company: any,
  refetch: Function,
}

const EditCompanyLinkModal: React.FC<EditCompanyLinkModalProps> = ({visible, onClose, link, id, company, refetch}) => {
  const [form] = useForm()
  const [isDisable, setIsDisabled] = useState(true);
  const {isAuth} = useSelector((state: RootState) => state.isAuth);

  const [updateCompany] = useUpdateCompanyMutation();

  const handleFinish = async () => {
    try {
      await updateCompany({
        id: company.id ?? '',
        accessToken: isAuth,
        body: {
          link: form.getFieldValue('link') ?? ''
        }
      }).unwrap();

      refetch();
      onClose();
    } catch (error) {
      console.error(error);
    }
  }

  const isValidLink = (str: string): boolean => {
    const pattern = /^(https?:\/\/)?[\w.-]+\.[a-z]{2,}([\/\w .-]*)*\/?$/i;
    return pattern.test(str);
  };

  const handleInputChange = (e: any) => {
    setIsDisabled(!isValidLink(e.link) || !form.isFieldTouched('link'));
  };

  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      maskClosable={true}
      onCancel={onClose}
      centered
      className={'EditCompanyLinkModal'}
    >
      <Flex vertical>
        <Flex justify="space-between" align="center" className={'EditCompanyLinkModal__header'}>
          <h3>Edit link</h3>
          <CrossIcon color={"#000000"} onClick={() => {
            form.setFieldValue('link', link);
            onClose();
          }} />
        </Flex>
        <Flex className={'EditCompanyLinkModal__body'}>
          <Form
            form={form}
            initialValues={{ link }}
            onFinish={handleFinish}
            layout="vertical"
            className={'EditCompanyLinkModal__body__form'}
            onValuesChange={handleInputChange}
          >
            <Form.Item
              name="link"
              label="Attach links to business social media"
              rules={[
                { required: true, message: '' },
              ]}
            >
              <Input placeholder="Link" className={'EditCompanyLinkModal__body__form__input'} />
            </Form.Item>

            <Form.Item>
              <Flex className={'EditCompanyLinkModal__body__form__button'}>
                <CustomButton text="Save" disable={isDisable} htmlType="submit" />
              </Flex>
            </Form.Item>
          </Form>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default EditCompanyLinkModal;